<div class="card" *ngIf="loading">
    <div class="card-body flex justify-center" style="margin-top: 20px;">
        <app-preloader ></app-preloader>
    </div>
</div>
<ng-container *ngIf="!loading && themes.length === 0">
    <div class="card">
        <div class="card-body">
            <h6 class="text-lg text-gray-500 font-semibold mb-6">Owned Themes</h6>
            <div class="flex justify-center">
                <img src="./assets/images/profile/no-record-found.png" alt="" class="w-100px h-100px">
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="!loading && themes.length > 0">
    <div class="sm:flex items-center justify-between mt-3 mb-4">
        <h3 class="mb-3 sm:mb-0 font-semibold text-dark dark:text-white text-2xl gap-2 flex items-center">
            Owned Themes
        </h3>
    </div>
    <div class="lg:col-span-12 md:col-span-12 sm:col-span-12 col-span-12">
        <div class="grid grid-cols-4 gap-6 mb-6">
            <div class="lg:col-span-4 md:col-span-4 sm:col-span-3 col-span-3"  *ngFor="let theme of themes">
                <div class="card" style="cursor: pointer;" routerLink="">
                    <div class="card-body">
                        <div class="flex justify-center gap-4">
                            <div>
                                <img [src]="theme.imageUrl" alt="theme" class="w-12 h-12 rounded-full">
                                <p class="text-fs_15 font-medium">{{ theme.name }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>